// Appearance Status Constants
export const APPEARANCE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
  PROCESSING: "processing",
  FAILED: "failed"
};

// Image Upload Status Constants
export const IMAGE_UPLOAD_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
  PENDING: "pending",
  UPLOADING: "uploading"
};

// Action Types
export const APPEARANCE_ACTION_TYPES = {
  FETCH_APPEARANCES_REQUEST: "FETCH_APPEARANCES_REQUEST",
  FETCH_APPEARANCES_SUCCESS: "FETCH_APPEARANCES_SUCCESS",
  FETCH_APPEARANCES_FAILURE: "FETCH_APPEARANCES_FAILURE",

  DELETE_APPEARANCE_REQUEST: "DELETE_APPEARANCE_REQUEST",
  DELETE_APPEARANCE_SUCCESS: "DELETE_APPEARANCE_SUCCESS",
  DELETE_APPEARANCE_FAILURE: "DELETE_APPEARANCE_FAILURE",

  UPDATE_APPEARANCE_REQUEST: "UPDATE_APPEARANCE_REQUEST",
  UPDATE_APPEARANCE_SUCCESS: "UPDATE_APPEARANCE_SUCCESS",
  UPDATE_APPEARANCE_FAILURE: "UPDATE_APPEARANCE_FAILURE",

  SUBMIT_APPEARANCE_REQUEST: "SUBMIT_APPEARANCE_REQUEST",
  SUBMIT_APPEARANCE_SUCCESS: "SUBMIT_APPEARANCE_SUCCESS",
  SUBMIT_APPEARANCE_FAILURE: "SUBMIT_APPEARANCE_FAILURE",

  ENROLL_APPEARANCE_REQUEST: "ENROLL_APPEARANCE_REQUEST",
  ENROLL_APPEARANCE_SUCCESS: "ENROLL_APPEARANCE_SUCCESS",
  ENROLL_APPEARANCE_FAILURE: "ENROLL_APPEARANCE_FAILURE",
  RESET_ENROLL_STATES: "RESET_ENROLL_STATES",
  RETRY_FAILED_IMAGE_REQUEST: "RETRY_FAILED_IMAGE_REQUEST",
  RETRY_FAILED_IMAGE_FAILURE: "RETRY_FAILED_IMAGE_FAILURE",

  CREATE_APPEARANCE_REQUEST: "CREATE_APPEARANCE_REQUEST",
  CREATE_APPEARANCE_SUCCESS: "CREATE_APPEARANCE_SUCCESS",
  CREATE_APPEARANCE_FAILURE: "CREATE_APPEARANCE_FAILURE",

  UPLOAD_APPEARANCE_IMAGE_REQUEST: "UPLOAD_APPEARANCE_IMAGE_REQUEST",
  UPLOAD_APPEARANCE_IMAGE_SUCCESS: "UPLOAD_APPEARANCE_IMAGE_SUCCESS",
  UPLOAD_APPEARANCE_IMAGE_FAILURE: "UPLOAD_APPEARANCE_IMAGE_FAILURE",

  DELETE_APPEARANCE_IMAGE_REQUEST: "DELETE_APPEARANCE_IMAGE_REQUEST",
  DELETE_APPEARANCE_IMAGE_SUCCESS: "DELETE_APPEARANCE_IMAGE_SUCCESS",
  DELETE_APPEARANCE_IMAGE_FAILURE: "DELETE_APPEARANCE_IMAGE_FAILURE",

  RESET_CREATE_SUCCESS: "RESET_CREATE_SUCCESS",
  RESET_CREATE_STATES: "RESET_CREATE_STATES",

  SET_SELECTED_APPEARANCE: "SET_SELECTED_APPEARANCE",
  CLEAR_APPEARANCE_ERROR: "CLEAR_APPEARANCE_ERROR",

  FETCH_ASSOCIATED_STREAMS_REQUEST: "FETCH_ASSOCIATED_STREAMS_REQUEST",
  FETCH_ASSOCIATED_STREAMS_SUCCESS: "FETCH_ASSOCIATED_STREAMS_SUCCESS",
  FETCH_ASSOCIATED_STREAMS_FAILURE: "FETCH_ASSOCIATED_STREAMS_FAILURE",

  DOWNLOAD_APPEARANCE_IMAGES_REQUEST: "DOWNLOAD_APPEARANCE_IMAGES_REQUEST",
  DOWNLOAD_APPEARANCE_IMAGES_SUCCESS: "DOWNLOAD_APPEARANCE_IMAGES_SUCCESS",
  DOWNLOAD_APPEARANCE_IMAGES_FAILURE: "DOWNLOAD_APPEARANCE_IMAGES_FAILURE",

  // Advanced Config Selection
  SET_ADVANCED_CONFIG_APPEARANCES: "SET_ADVANCED_CONFIG_APPEARANCES",
  CLEAR_ADVANCED_CONFIG_APPEARANCES: "CLEAR_ADVANCED_CONFIG_APPEARANCES",
  SET_ADVANCED_CONFIG_THRESHOLDS: "SET_ADVANCED_CONFIG_THRESHOLDS",
  SET_ADVANCED_CONFIG_RADIO: "SET_ADVANCED_CONFIG_RADIO"
};

// UI Text Constants
export const APPEARANCE_TEXT = {
  PAGE_TITLE: "Enrolled Appearance",
  SUBTITLE: "Create an appearance to detect uniforms and other clothing indicating an employee.",
  CREATE_APPEARANCE: "Create Appearance",
  EDIT_APPEARANCE: "Edit Appearance",
  CANCEL_APPEARANCE: "Cancel",
  NEXT_BUTTON: "Next",
  DONE_BUTTON: "Done",
  BACK_TXT: "Back",
  NAME_APPEARANCE: "Name Appearance",
  UPLOAD_IMAGES: "Upload images for appearance ",
  NO_APPEARANCES: "No enrolled appearances found",
  NO_APPEARANCES_DESC: "Start by creating a new appearance enrollment",
  DELETE_CONFIRMATION_TITLE: "Confirm deletion",
  DELETE_CONFIRMATION_MESSAGE: "Are you sure you want to delete the Enrolled Appearance: ",
  DELETE_CONFIRMATION_APPEARANCE_LABEL: "Appearance:",
  DELETE_BUTTON: "Yes, Delete",
  CANCEL_BUTTON: "Cancel",
  EDIT_BUTTON: "Edit",
  ENROLL_BUTTON: "Enroll",
  STATUS_LABEL: "Status:",
  IMAGES_LABEL: "Images:",
  VIEW_STREAMS: "View deployments",
  VIEW_ENROLLED_SITES: "View enrolled sites",
  VIEW_ENROLLED_SITES_TITLE: "Enrolled sites for",
  ENROLLED_LABEL: "Enrolled",
  DELETE_SUCCESS: "Appearance deleted successfully",
  DELETE_ERROR: "Unable to delete appearance",
  FETCH_ERROR: "Unable to load appearances. Please try again.",
  BREADCRUMB_SETTINGS: "Settings",
  BREADCRUMB_ENROLLED_APPEARANCE: "Enrolled Appearance",
  DEFAULT_APPEARANCE_NAME: "Barista apron",
  DEFAULT_STATUS: "Review",
  NO_IMAGES: "No images",
  UPLOAD_IMAGE_ERROR_BANNER: "Image upload failed. Please try again.",
  DELETE_IMAGE_ERROR_BANNER: "Image delete failed. Please try again.",
  DELETE_IMAGE_SUCCESS_BANNER: "Image deleted successfully.",
  IMAGE_FAILED_TO_LOAD: "Image failed to load",
  DELETE_IMAGE_TITLE: "Delete image",
  EDIT_IMAGE_TITLE: "Edit image",
  DELETE_APPEARANCE_TITLE: "Delete appearance",
  IMAGE_ALT_TEXT: "Appearance",
  NO_SITES_MATCHED: "No sites matched",
  DO_IT_LATER: "Do it later",
  NO_IMAGE_UPLOADED: "No Image Uploaded",

  // Notification content
  DELETE_APPEARANCE_SUCCESS_TITLE: "Appearance deleted",
  DELETE_APPEARANCE_SUCCESS_SUBTITLE: "The appearance has been successfully deleted.",
  DELETE_APPEARANCE_FAILURE_TITLE: "Unable to delete appearance",
  DELETE_APPEARANCE_FAILURE_SUBTITLE: "Something went wrong while deleting the appearance. Please try again.",

  // Image delete notifications
  IMAGE_DELETE_SUCCESS_TITLE: "Image deleted",
  IMAGE_DELETE_SUCCESS_SUBTITLE: "The image has been successfully removed.",
  IMAGE_DELETE_FAILURE_TITLE: "Unable to delete image",
  IMAGE_DELETE_FAILURE_SUBTITLE: "Something went wrong while deleting the image. Please try again.",

  // Image delete confirmation modal
  DELETE_IMAGE_CONFIRMATION_TITLE: "Confirm deletion",
  DELETE_IMAGE_CONFIRMATION_MESSAGE: "Are you sure you want to delete this image?",

  // Generic progress text
  DELETING_PROGRESS: "Deleting...",

  // Deploy Modal
  DEPLOY_MODAL_TITLE: "Enroll",
  DEPLOYMENT_DELETE_LOCK_TITLE: "Cannot delete",
  DEPLOYMENT_UNENROLL_LOCK_TITLE: "Cannot unenroll",
  DEPLOYMENT_LOCK_BODY_BEFORE: "This appearance is currently in use in one or more ",
  DEPLOYMENT_LOCK_LINK_TEXT: "deployments",
  DEPLOYMENT_LOCK_BODY_AFTER: " and cannot be unenrolled.",
  DEPLOYMENT_DELETE_LOCK_BODY_AFTER: " and cannot be deleted.",
  SELECT_ALL: "Select all",
  PLEASE_TRY_AGAIN: "Please try again",
  DEPLOY_FAILED_FALLBACK: "Failed to deploy. Please try again.",
  RETRY_VALIDATE_ERROR: "Failed to validate. Please try again later.",
  MY_EAS_TAB: "My Enrolled Appearances",
  OTHER_EAS_TAB: "Other Enrolled Appearances",
  CROSS_SITE_WARNING_TITLE: "Cross-site appearance",
  CROSS_SITE_WARNING_BODY: "This appearance is managed by another site. Enroll it into your site before editing.",
  CROSS_SITE_ADV_CONFIG_TITLE: "Access Denied",
  CROSS_SITE_ADV_CONFIG_BODY: "This Appearance is not enrolled in the site associated with this camera/device. Please enroll it in the target site before deploying the ROI.",
  ENROLL_AND_EDIT: "Enroll & Edit",
  UPDATE_SITE: "Update site",
  SUBMIT_TO_CCD: "Submit appearance",
  DEPLOY_TO_COMPANION: "Submit",
  DEPLOY_TO_COMPANION_ERROR: "Failed to enroll",
  COMPANION_DEVICES: "Companion devices",
  SITES: "Sites",
  DEPLOYED_TO_SITE: "Appearance deployed to site",
  NOT_DEPLOYED_TO_SITE: "Appearance not submitted to any site",
  DEPLOYED_TO_CCD: "Appearance deployed to Companion",
  NOT_DEPLOYED_TO_CCD: "Appearance not deployed to any Companion",
  CONFIRM_BUTTON: "Confirm",
  CUSTOMIZE_BUTTON: "Customize",
  CONFIRM_DEPLOY_DESCRIPTION:
    "Clicking on confirm will deploy appearance: [appearance_name], to all sites and associated companions for the account: [account_id]",
  CONFIRM_DEPLOY_MODAL_TITLE: "Confirm Deploy?",
  CONFIRM_DEPLOY_MODAL_ARIA_LABEL: "Confirm deploy modal",
  SELECTED_COMPANIONS_COUNT_SINGULAR: "Selected: [count] Companion",
  SELECTED_COMPANIONS_COUNT_PLURAL: "Selected: [count] Companions",
  LOCKED_COMPANION_WARNING: "Appearance cannot be removed from enrolled devices",

  // EAList badge/icon text
  ERROR_FOUND: "invalid image",
  ERRORS_FOUND: "invalid images",
  INVALID_UPLOAD_IMAGES: "No images uploaded",
  INVALID_IMAGE_TOOLTIP_TITLE: "Invalid Image",
  INVALID_IMAGE_TOOLTIP_DESC: "Image to be deleted as it doesnt meet the image ",
  INVALID_IMAGE_GUIDELINES_LINK: "guidelines",

  // Derived status labels & tooltips
  PROCESSING_LABEL: "Processing",
  PROCESSING_FAILED_LABEL: "Processing failed",
  ACTIVE_LABEL: "Ready to use",
  MANAGE_APPEARANCE_ENROLL_MESSAGE: "To manage this appearance, please enroll it into one of the sites listed below.",
  ENROLLED_APPEARANCES_BREADCRUMB: "Enrolled Appearances",
  APPEARANCE_NAME_FALLBACK: "Appearance Name",
  CAMERAS_BREADCRUMB: "Cameras",
  REGIONS_OF_INTEREST_BREADCRUMB: "Regions of Interest",
  EVENT_DETAILS_BREADCRUMB: "Event Details",
  CV_APP_CONFIGURATION_BREADCRUMB: "CV App Configuration",
  VALID_STATUS_LABEL: "Valid",
  NOT_ENROLLED_TO_ANY_SITE: "Not enrolled to any site",
  NO_ACTIVE_DEPLOYMENTS: "No active deployments",
  OUT_OF_SYNC_LABEL: "Out of Sync",
  PROCESSING_TOOLTIP: "Appearance is getting deployed to device",
  PROCESSING_FAILED_TOOLTIP: "Looks like there was an issue when processing your EA. Please initiate the process again by clicking on enroll.",
  ACTIVE_TOOLTIP: "Successfully enrolled to all the selected sites",
  OUT_OF_SYNC_TOOLTIP: "One or more of the deployments is using an outdated version of this appearance. For more details, click on view deployments.",

  // Deploy appearance notifications
  SUCCESSFULLY_DEPLOYED_TITLE: "Enrollment Success",
  ENROLLED_TO_PREFIX: "Successfully Enrolled to",
  UNENROLLED_FROM_PREFIX: "Successfully Unenrolled from",
  ENROLLED_AND_UNENROLLED_JOIN: "and Unenrolled from",
  SITE_SINGULAR: "site",
  SITE_PLURAL: "sites",

  // Processing required modal
  PROCESSING_REQUIRED_TITLE: "Processing required",
  PROCESSING_REQUIRED_BODY_BEFORE: "This Appearance must be in an ",
  PROCESSING_REQUIRED_BODY_ACTIVE: "Active (Ready to use)",
  PROCESSING_REQUIRED_BODY_AFTER: " state to deploy. You can trigger process now to make it ready.",
  PROCESSING_REQUIRED_ARIA_LABEL: "Processing required modal",
  PROCESS_NOW_BUTTON: "Process Now",
  ROI_POLYGON_CONFIGURATION: "Roi polygon configuration"
};

export const CREATE_APPEARANCE = {
  UPLOAD_DESCRIPTION:
    "Upload images that capture the appearance from different angles and lighting. There are no limits on the number of images. At least 5 is recommended.",
  UPLOAD_DESCRIPTION_EDIT: "Upload images that capture the appearance from different angles and lighting.",
  DRAG_TO_UPLOAD: "Drag files to upload",
  MAX_FILE_SIZE_DESC: "Max file size: [placeholder] MB",
  BROWSE_TXT: "Browse",
  ADD_MORE_TXT: "Add More",
  FILE_SIZE_ERROR: "Unable to upload.",
  SUPPORTED_FILE_TYPES: "Supported file types: JPG, PNG, JPEG",
  FAILED_TO_CREATE_APPEARANCE: "Unable to create appearance",
  FAILED_TO_GET_APPEARANCE: "Unable to load appearance details. Please try again.",
  CLOSE: "Close",
  INVALID_FILE_TYPE: "Unsupported file type",
  INVALID_FILE_DESC: "The selected file type is not supported. Please upload a file in one of the following formats: [placeholder].",
  INPUT_VALIDATION_FAILED: "Invalid appearance name",
  INPUT_VALIDATION_ERROR:
    "Appearance name can contain only alphanumeric characters, spaces, underscores, and dashes with a minimum length of 5 and maximum length of 50 characters.",
  DUPLICATE_APPEARANCE_NAME_ERROR: "Appearance name already exists. Please use another name for the appearance.",
  MIN_LENGTH_ERROR: "Name must be at least 5 characters",
  DOWNLOAD_IMAGE_ERROR: "Unable to load image. Please check your connection and try again.",
  UPLOAD_IMAGE_ERROR: "Unable to upload image. Please try again.",
  DELETE_IMAGE_ERROR: "Unable to delete image. Please try again.",
  IMAGE_SIZE_TOO_LARGE: "This image exceeds the maximum file size of [placeholder] MB. Please resize it and try again.",
  IMAGE_SIZE_TOO_LARGE_TITLE: "Upload failed - file size has exceeded the limit of [placeholder] MB",
  MAX_FILE_SIZE_MB: 25,
  APPEARANCE_NAME_REQUIRED: "Please enter an appearance name",
  // Image Guidelines captions
  DO_CAPTION_1: "Tightly cropped on the uniform",
  DO_CAPTION_2: "Different angles & lighting",
  DONT_CAPTION_1: "Blurry or obstructed views",
  DONT_CAPTION_2: "Images with many people in the scene",
  DONT_CAPTION_3: "Uncropped wide shots",
  VALID_IMAGES_LABEL: "Valid",
  INVALID_IMAGES_LABEL: "Invalid",
  UPLOADING_IMAGES_LABEL: "Uploading",
  VALIDATING_IMAGES_LABEL: "Under Validation",
  FAILED_UPLOAD_IMAGES_LABEL: "Failed to Upload",
  DEPLOY_STATUS_VALID: "Deployed",
  DEPLOY_STATUS_FAILED: "Failed"
};

export const DEPLOY_LOCKED_TOOLTIP = "Select sites to enroll this Appearance.";

// Image Guidelines Text Constants
export const IMAGE_GUIDELINES_TEXT = {
  TITLE: "Image Guidelines",
  INTRO: "Follow these tips to ensure your images are processed quickly and accurately:",
  DO_TITLE: "Do's",
  DONT_TITLE: "Don'ts",
  ALT_BANNER: "Image guidelines",
  ALT_DO_PREFIX: "Do example",
  ALT_DONT_PREFIX: "Don't example",
  ARIA_OPEN_MODAL: "Open image guidelines",
};


// Aria Labels for Error Modals
export const ARIA_LABELS = {
  INPUT_VALIDATION_ERROR: "Input validation error",
  CREATION_FAILURE_ERROR: "Enrolled Appearance creation failure",
  LIST_FAILURE_ERROR: "Appearance fetch failed"
};

// License Messages
export const LICENSE_MESSAGES = {
  NO_LICENSE_TITLE: "No Enrolled Appearance License",
  NO_LICENSE_SUBTITLE: "You need an active Enrolled Appearance license to access this feature. Please contact your administrator to get the appropriate license.",
  LICENSE_FETCH_ERROR: "Failed to fetch licenses. Please try again later."
};

// Runtime status strings seen from services/UI for appearance cards
export const APPEARANCE_RUNTIME_STATUS = {
  READY_FOR_USE: "Ready for use",
  NEW: "new",
  PROCESSING: "processing",
  FAILED: "failed",
  INVALID: "invalid",
  SUBMITTED: "submitted",
  VALID: "valid",
  VALIDATING: "validating",
  ACTIVE: "active",
};

export const STATUS_BADGE_BG_COLORS = {
  [APPEARANCE_RUNTIME_STATUS.NEW]: "#000000",
  [APPEARANCE_RUNTIME_STATUS.VALID]: "#026f28",
  [APPEARANCE_RUNTIME_STATUS.UPDATED]: "#ffc800",
  [APPEARANCE_RUNTIME_STATUS.SUBMITTED]: "#6b7280",
  [APPEARANCE_RUNTIME_STATUS.INVALID]: "#FF8027",
  [APPEARANCE_RUNTIME_STATUS.FAILED]: "#FF8027",
  errors: "#FF8027"
};

export const STATUS_BADGE_TEXT_COLORS = {
  [APPEARANCE_RUNTIME_STATUS.NEW]: "#ffffff",
  [APPEARANCE_RUNTIME_STATUS.VALID]: "#ffffff",
  [APPEARANCE_RUNTIME_STATUS.INVALID]: "#ffffff",
  [APPEARANCE_RUNTIME_STATUS.FAILED]: "#ffffff",
  [APPEARANCE_RUNTIME_STATUS.UPDATED]: "#000000",
  [APPEARANCE_RUNTIME_STATUS.SUBMITTED]: "#ffffff",
  errors: "#ffffff"
};

export const IMAGE_STATUS_ICON_BG_COLORS = {
  [APPEARANCE_RUNTIME_STATUS.VALID]: "#008331",
  [APPEARANCE_RUNTIME_STATUS.INVALID]: "#FF8027",
  [APPEARANCE_RUNTIME_STATUS.VALIDATING]: "#ffc800",
  [APPEARANCE_RUNTIME_STATUS.NEW]: "#ffc800",
  [APPEARANCE_RUNTIME_STATUS.FAILED]: "#6f7171"
};

export const BADGE_COLORS = {
  BG_PROCESSING: "#ffc800",
  BG_ACTIVE: "#026f28",
  BG_OUT_OF_SYNC: "#ffc800",
  BG_VALID: "#E3F2FD",
  TEXT_WHITE: "#ffffff",
  TEXT_BLACK: "#000000",
};

export const DEPLOY_MODAL_COMPANION_STATUS_COLORS = {
  online: { bg: "#026f28", text: "#ffffff" },
  offline: { bg: "##ff8027;", text: "#ffffff" },
  outdated: { bg: "#6f7171", text: "#ffffff" },
  submitted: { bg: "#ffc800", text: "#000000" },
  deployed: { bg: "#026f28", text: "#ffffff" }
};

export const DEPLOY_MODAL_DEFAULT_STATUS_COLOR = { bg: "#93c5fd", text: "#000000" };

// Additional UI Text
export const SITES_TEXT = {
  INTRO: "Select the sites that should have access to the Enrolled Appearances (default: all).",
};

// Advanced Configuration Constants
export const ADVANCED_CONFIG = {
  // Radio Button Labels
  RADIO_OPTION_TITLE: "Alert me when the appearance",
  PC_RADIO_OPTION_PREFIX: "Count people when the appearance",
  RADIO_OPTION1_BOLD: "IS NOT",
  RADIO_OPTION1_SUFFIX: "present",
  PC_RADIO_OPTION1_DESCRIPTION: "Ex: Select \"green aprons\" to count all people but omit people wearing \"green aprons\".",
  RADIO_OPTION1_DESCRIPTION: "Ex: Select \"green aprons\" to receive alerts for all people who are not wearing \"green aprons\".",
  RADIO_OPTION2_BOLD: "IS",
  RADIO_OPTION2_SUFFIX: "present",
  PC_RADIO_OPTION2_DESCRIPTION: "Ex: Select \"green aprons\" to count only the people detected wearing \"green aprons\".",
  RADIO_OPTION2_DESCRIPTION: "Ex: Select \"green aprons\" to receive alerts when only people are detected with \"green aprons\".",

  // License Info
  LICENSE_TOOLTIP_TITLE: "Enrolled appearance license",
  LICENSE_TOOLTIP_DESCRIPTION: "The first time an appearance is selected for a stream, it will count towards the usage of an enrolled appearance license. Thereafter an unlimited amount of appearances can be used for that stream and it will not impact usage.",
  LICENSES_AVAILABLE: "licenses available",

  // Dropdown Labels
  APPEARANCE_LABEL: "Appearance",
  CHOOSE_OPTION: "Choose an option",
  OTHER_OPTION: "Other (Did not find any)",

  // Custom Name Input
  APPEARANCE_NAME_LABEL: "Appearance name",
  APPEARANCE_NAME_HELPER: "Enter appearance name.",
  APPEARANCE_NAME_PLACEHOLDER: "e.g., Blue Uniform",

  // Loading and States
  LOADING_IMAGES: "Loading images...",

  // Buttons
  ADD_APPEARANCE: "Add appearance",
  RESET_TO_DEFAULT: "Reset thresholds to default",

  // Threshold Labels
  CAPTURE_THRESHOLD_LABEL: "Appearance capture threshold",
  MATCHING_THRESHOLD_LABEL: "Appearance matching threshold",
  DEFAULT_LABEL: "Default:",
  ERROR_RANGE: "Enter value from",

  // Navigation Modal
  NAVIGATION_MODAL_TITLE: "Confirm navigation",
  NAVIGATION_MODAL_MESSAGE: "Navigating to the license details page will discard all the changes you've made in the advanced configuration. Are you sure you want to proceed?",
  NAVIGATION_MODAL_YES: "Yes",
  NAVIGATION_MODAL_NO: "No",

  // Default Values
  TOTAL_LICENSES_AVAILABLE: 50,
  DEFAULT_CAPTURE_THRESHOLD: 70,
  DEFAULT_MATCHING_THRESHOLD: 5,
  MINIMUM_VAL: 1,
  MAX_VAL: 99,

  // Keyboard Keys
  KEY_ENTER: 'Enter',
  KEY_SPACE: ' ',

  // Dropdown Values
  DROPDOWN_VALUE_ADD_NEW: 'add_new',

  NO_IMAGES_AVAILABLE_PREFIX: "This Appearance has no reference images. ",
  NO_IMAGES_AVAILABLE_LINK: "Add at least one image",
  NO_IMAGES_AVAILABLE_SUFFIX: " to enable deployment.",

  // Field Names to Skip in Payload
  FIELDS_TO_SKIP: ['appearance_name', 'appearance_id', 'in_appearance'],

  // Config Parameter Keys
  DEPLOY_PARAMETERS: "deploy-parameters",

  // Field Names
  ENABLE_APPEARANCE: "enable_appearance",
  ENABLE_ENROLLED_APPEARANCE: "enable_enrolled_appearance",
  COLORS: "colors",
  APPEARANCES: "appearances",
  ENROLLED_APPEARANCE_PARAMETERS: "enrolled_appearance_parameters",
  APPEARANCE_NAME: "appearance_name",
  APPEARANCE_ID: "appearance_id",
  APPEARANCE_EMBEDDING: "appearance_embedding",
  IN_APPEARANCE: "in_appearance",
  IS_COLOR_EXCLUSION_SET: "is_color_exclusion_set",
  APPEARANCE_CAPTURE_THRESHOLD: "appearance_capture_threshold",
  APPEARANCE_MATCHING_THRESHOLD: "appearance_matching_threshold",

  // Cache status values
  CACHE_STATUS_ERROR: "error",
  CACHE_STATUS_FAILED: "failed",

  SELECT_DROPDOWN: "Select",
  CREATE: "create",
  UPDATE: "update",

  NO_ENROLLED_APPEARANCES_PREFIX: "No Enrolled Appearances found. ",
  NO_ENROLLED_APPEARANCES_LINK: "Create an Enrolled Appearance",
  NO_ENROLLED_APPEARANCES_SUFFIX: " to proceed.",

  // Advanced config - Cross site - Deploy modal messaging
  DEPLOY_ENROLL_SITE_MESSAGE_PREFIX: "Please Enroll in ",
  DEPLOY_ENROLL_SITE_MESSAGE_MID: " to use this appearance for camera stream ",
  DEPLOY_ENROLL_SITE_MESSAGE_SUFFIX: ".",

  // Navigate-away reset tracking (dispatched as clearAdvancedConfigAppearances callFrom label)
  NAVIGATE_AWAY_CREATE_APPEARANCE: "navigate_away_create_appearance",
  NAVIGATE_AWAY_EDIT_APPEARANCE: "navigate_away_edit_appearance",

  NA: "NA",
};

// Notification Messages for Edit Flow
export const EDIT_FLOW_NOTIFICATIONS = {
  ENROLLED_APPEARANCE: {
    TITLE: "Enrolled appearance",
    SUBTITLE: "Add the ability to detect uniforms and other clothing indicating an employee. Contact sales to learn more."
  },
  COLOR_DETECTION_DISABLED: {
    TITLE: "Color detection is not available",
    SUBTITLE: "In order to switch to color detection you have to delete this app and create a new app."
  },
  ENROLLED_APPEARANCE_DISABLED: {
    TITLE: "Enrolled appearance is not available",
    SUBTITLE: "In order to switch to enrolled appearance detection you have to delete this app and create a new app."
  },
};

export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS42IDIxLjYiPjxwYXRoIGQ9Ik0xMC44MDIxMywxOS44MDEyMmEyLjM5NTY3LDIuMzk1NjcsMCwwLDEtMS43MDUtLjcwN0wyLjUwNzQzLDEyLjUwNDQ0YTIuNDEyNDQsMi40MTI0NCwwLDAsMSwwLTMuNDA5MTNMOS4wOTgwOCwyLjUwNTU1YTIuNDE1OTEsMi40MTU5MSwwLDAsMSwzLjQwOTA4LS4wMDFsNi41ODk2Nyw2LjU5MDczYTIuNDEyNDQsMi40MTI0NCwwLDAsMSwwLDMuNDA5MTNMMTIuNTA3MTYsMTkuMDk0MkEyLjM5NCwyLjM5NCwwLDAsMSwxMC44MDIxMywxOS44MDEyMlptLTcuNDk5OC05LjkxMWExLjI4OSwxLjI4OSwwLDAsMCwwLDEuODE5MzFMOS44OTMsMTguMjk5MjlhMS4zMTQ3NiwxLjMxNDc2LDAsMCwwLDEuODE5MjgsMGw2LjU4OTY3LTYuNTg5NzZhMS4yODksMS4yODksMCwwLDAsMC0xLjgxOTMxTDExLjcxMjI2LDMuMzAwNDdhMS4yOTA3NiwxLjI5MDc2LDAsMCwwLTEuODE5MjgsMFpNOS45NSwxNS4wNWgxLjdWMTMuMzY3SDkuOTVabTAtNi4wMDk1My41NjEsMi42MzVoLjU2OTUybC41Njk1MS0yLjYzNVY2LjU1SDkuOTVaIi8+PC9zdmc+";

export const ASSOCIATE_STREAMS = "associateStreams";
